import { emptyError } from "../../Types/ServicesType/servicesType";
import api from "@services/apiList";
import instance from "@services/services";
const { reportsApi } = api;


export const reconcilationReportTable = async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi.reconsilationReport,data)
        console.log("fadu:",result);
        return result.data
    } catch (error) {
        return emptyError
    }
}
export const reconcilationlistexcelService = async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi.reconsilationReportSearchexcel,data)
        console.log("iwiwiuiesxcesclll:",result);
        return result.data
    } catch (error) {
        return emptyError
    }
}



